export const ADMIN_ADD_COURSE_REQUEST = 'ADMIN_ADD_COURSE_REQUEST';
export const ADMIN_ADD_COURSE_SUCCESS = 'ADMIN_ADD_COURSE_SUCCESS';
export const ADMIN_ADD_COURSE_FAIL = 'ADMIN_ADD_COURSE_FAIL';

export const ADMIN_GET_COURSE_REQUEST = 'ADMIN_GET_COURSE_REQUEST';
export const ADMIN_GET_COURSE_SUCCESS = 'ADMIN_GET_COURSE_SUCCESS';
export const ADMIN_GET_COURSE_FAIL = 'ADMIN_GET_COURSE_FAIL';

export const ADMIN_UPDATE_COURSE_REQUEST = 'ADMIN_UPDATE_COURSE_REQUEST';
export const ADMIN_UPDATE_COURSE_SUCCESS = 'ADMIN_UPDATE_COURSE_SUCCESS';
export const ADMIN_UPDATE_COURSE_FAIL = 'ADMIN_UPDATE_COURSE_FAIL';

export const ADMIN_DELETE_COURSE_REQUEST = 'ADMIN_DELETE_COURSE_REQUEST';
export const ADMIN_DELETE_COURSE_SUCCESS = 'ADMIN_DELETE_COURSE_SUCCESS';
export const ADMIN_DELETE_COURSE_FAIL = 'ADMIN_DELETE_COURSE_FAIL';

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 
